import GTMData from "@/types/gtm/QuoteGtmEvent";

export const defaultViewQuoteData = {
  event: "ecom_events",
  event_name: "view_item_list",
  step_name: "order confirmation",
  first_name: null,
  last_name: null,
  email_address: null,
  phone_number: null,
  age: null,
  trip_type: null,
  cover_start_date: null,
  cover_end_date: null,
  travel_from: null,
  travel_group_type: null,
  amount_of_cover_medical: null,
  amount_of_cover_cancellation: null,
  amount_of_cover_baggage: null,
  excess: null,
  covid_cover: null,
  legal_protection: null,
  repatriation: null,
  personal_liability: null,
  winter_sports: null,
  travel_disruption: null,
  excess_waiver: null,
  gadget_cover: null,
  golf_cover: null,
  car_hire_excess_waiver: null,
  quote_id: null,
  medical_condition_added: null,
} as unknown as GTMData;
